export default __webpack_public_path__ + "static/media/Ready_to_use.168a2bb7.png";